import { render, staticRenderFns } from "./RegionHandler.vue?vue&type=template&id=28f49e11"
import script from "./RegionHandler.vue?vue&type=script&lang=ts"
export * from "./RegionHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports